import { combineReducers } from "redux";
import productReducer from "./products/reducer";
import submitRfpReducer from "./submitRfp/reducer";
import updateRfpReducer from "./updateRfp/reducer";






const rootReducer = combineReducers({
  product: productReducer,
  updateRfp: updateRfpReducer,
  submitRfp: submitRfpReducer,
});

// const rootReducer = (state, action) => {
// 	if (action.type === AccountActionTypes.LOGOUT) {
// 		state = undefined;
// 	}
// 	return appReducer(state, action);
// };

export default rootReducer;